
export const BUSINESS_CATEGORY_KEYS = {
  PROVIDER: 'Provider',
  OTHERS: 'Others',
  FARM: 'Farm'
} as const;

export const PERSON_ROLE_KEYS = {
  EMPLOYEE: 'EMPLOYEE',
  BUSINESS_ADMIN: 'Business Admin',
  PROVIDER_MANAGER: 'Provider Manager',
} as const;

export type BusinessCategoryKey =
  typeof BUSINESS_CATEGORY_KEYS[keyof typeof BUSINESS_CATEGORY_KEYS];

export type PersonRoleKey =
  typeof PERSON_ROLE_KEYS[keyof typeof PERSON_ROLE_KEYS];